<template>
  <div>

    <hr>
    <!-- First Name, Last Name, Email -->
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
    >
      <b-row>
        <!-- First Name -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="First Name"
            label-for="firstName"
          >
            <validation-provider
              #default="{ errors }"
              name="First Name"
              rules="required"
            >
              <b-form-input
                id="firstName"
                v-model="newUser.firstName"
                :state="errors.length > 0 ? false : null"
                name="register-firstName"
                placeholder="John"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Last Name -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Last Name"
            label-for="lastName"
          >
            <validation-provider
              #default="{ errors }"
              name="Last Name"
              rules="required"
            >
              <b-form-input
                id="lastName"
                v-model="newUser.lastName"
                :state="errors.length > 0 ? false : null"
                name="register-lastName"
                placeholder="Doe"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- email -->

      <b-form-group
        label="Email"
        label-for="email"
      >
        <validation-provider
          #default="{ errors }"
          name="Email"
          rules="required|email"
        >
          <b-form-input
            id="email"
            v-model="newUser.email"
            :state="errors.length > 0 ? false : null"
            name="register-email"
            placeholder="john@example.com"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-button
        variant="primary"
        block
        :disabled="invalid"
        @click="nextTab"
      >
        Next
      </b-button>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BButton,
}
from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  components: {
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    newUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      email,
    }
  },
  methods: {
    async nextTab() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }
      this.$emit('nextTab')
    },
  },
}

</script>

<style>

</style>
